import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the current space record when a lab is assigned to or removed from
 * a lab service, so the history log and status reflect the change.
 */
export const reloadOnLabAssignmentChange = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceLabAssignment, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(labAssignmentsEc =>
        labAssignmentsEc.plugins.editingPlugin.feature.actions.submit.success
          .observe()
          .pipe(
            rxjs.map(() =>
              collection.plugins.currentEntityPlugin.feature.actions.getEntity
                .from('(effect) reload on lab assignment change')
                .create({}),
            ),
          ),
      ),
    ),
)
